import React, { useCallback, useMemo } from 'react';
import TextField from '@mui/material/TextField';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { calculateGrandTotal, handleDeleteRowCommon, useCartUtils } from '../ItemPageShared/ItemUtils';
import { validateDecimalInput } from '../../sharedFiles/Helper/utils';
import { useCart } from '../ItemPageShared/itemContext';

const ItemList = ({
    page,
    rowsPerPage,
    paginatedData,
    itemSearchTerm,
    handleDeleteRow,
}) => {
     const { handleQuantityChange } = useCartUtils();
const { cart ,setGrandTotal,setCartItems} = useCart();
    const cartMap = useMemo(() => {
        if (cart.length > 0) {
            const map = {};
            cart.forEach(item => {
                map[item.item_Code] = item;
            });
            return map;
        }
    }, [cart]);
    const handleRemoveItem =useCallback((index, item, content) => () => {
        let newIndex = 0;
        if (cart.length > 0) {
            newIndex = cart.length;
        }
        const value = cart.findIndex(
            key => key.item_Code.toLowerCase() === item?.item_Code.toLowerCase()
        );
        
        handleDeleteRow(value);
   
})
//     const handleAddToCartClick = useCallback((index, item, content) => () => {
//         console.log("itedfgdgm",item);
        
//         let newIndex = 0;
//         if (cart.length > 0) {
//             newIndex = cart.length;
//         }

//         const value = cart.findIndex(
//             key => key.item_Code.toLowerCase() === item?.item_Code.toLowerCase()
//         );

//         let updatedItem = {};

//         if (value === -1) {
//             updatedItem = {
//                 ...item,
//                 quantity: 1
//             };
//         } else {
//             if (content === "Add") {
//                 updatedItem = {
//                     ...item,
//                     quantity: parseFloat(cart[value].quantity) + 1
//                 };
//             } else {
//                 if (content === "Sub" && cart[value].quantity > 1) {
//                     updatedItem = {
//                         ...item,
//                         quantity: parseFloat(cart[value].quantity) - 1
//                     };
//                 } else {
//                     console.log("delete triggered at index", value);
//                     handleDeleteRow(value);
//                     return;
//                 }
//             }
//             newIndex = value;
//         }
// console.log("updatedItem",updatedItem,newIndex);
//         handleAddCart(updatedItem, newIndex);
//     }, [cart, handleAddCart, handleDeleteRow]);


const handleAddToCartClick = useCallback((index, item, content) => () => {
    let newIndex = cart.length > 0 ? cart.length : 0;
    const existingItemIndex = cart.findIndex(
        key => key.item_Code.toLowerCase() === item?.item_Code.toLowerCase()
    );
    if (existingItemIndex === -1) {
        updateCartItem(item, 1);
    } else {
        const existingItem = cart[existingItemIndex];
        let newQuantity = parseFloat(existingItem.quantity);

        if (content === "Add") {
            newQuantity += 1;
            updateCartItem(existingItem, newQuantity, existingItemIndex);
        } else if (content === "Sub") {
            if (newQuantity > 1) {
                newQuantity -= 1;
                updateCartItem(existingItem, newQuantity, existingItemIndex);
            } else {
                handleDeleteRow(existingItemIndex);
            }
        }
    }
}, [cart, handleDeleteRow]);





const updateCartItem = (item, quantity, index = null) => {
    const price = parseFloat(item.price_After_Discount) || parseFloat(item.price) || 0;
    const total = parseFloat((price * quantity).toFixed(2));

    const updatedItem = {
        ...item,
        quantity,
        total,
    };

    setCartItems((prevCartItems) => {
        const updatedItems = [...prevCartItems];
        if (index !== null) {
            updatedItems[index] = updatedItem;
        } else {
            updatedItems.push(updatedItem);
        }

        const grandTotal = calculateGrandTotal(updatedItems);
        setGrandTotal(grandTotal);
        sessionStorage.setItem("cart", JSON.stringify(updatedItems));
        return updatedItems;
    });
};






    // const handleInputChange = (index, event, item) => {
    //     const inputValue = event.target.value;
    //     const { isValid, values } = validateDecimalInput(inputValue);

    //     if (!isValid) return;
    //     const value = cart.findIndex(
    //         key => key.item_Code.toLowerCase() === item?.item_Code.toLowerCase()
    //     );

    //     if (!item) return;

    //     const updatedItem = {
    //         ...item,
    //         quantity: values > 0 ? values : 1 // values is now a number
    //     };

    //     handleAddCart(updatedItem, value);
    // };

    const capitalizeWords = (text) => {
        return text
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };
    return (
        <div className="item-inside-div col-12">
            {/* {!displayedItem || displayedItem.length === 0 ? ( */}
            {!paginatedData || paginatedData.length === 0 ? (
                <div className="noitem-div">
                    <div className="noitem">
                        <div className="noItemIcon"></div>
                        <p className="noItemIcon-text">
                            Oops! There is no Item available with this name
                            <span>{itemSearchTerm?.length > 2 ? itemSearchTerm : ""}</span>!
                        </p>
                    </div>
                </div>
            ) : (
                // displayedItem.map((item, index) => (
                    paginatedData && paginatedData.map((item, index) => (
                    <div className="itemDataBox position-relative">
                        <p className="m-0">
                            {item?.item_Name ? capitalizeWords(item?.item_Name) : "No Name Available"}
                        </p>
                        <p className="m-0">{item.item_Code}</p>
                        <div className="d-flex">
                            <div className="unit col-xl-12">
                                <div className="col-xl-6">
                                    <p>
                                        Discount Price : <span className="valueFont">₹{item?.discount_Price}</span>
                                    </p>
                                    <p>
                                        MRP : <span className="valueFont">₹{item.price}</span>
                                    </p>
                                </div>
                                {/* <div className="col-xl-6">
                                    <p className="valueFont amountPosistion">
                                        ₹{item.defaultPriceList?.toLocaleString()}/-
                                    </p>
                                </div> */}
                            </div>
                        </div>
                        {/* <TextField
                            className="PriceList"
                            id="standard-basic"
                            variant="standard"
                            onClick={() => handlePriceList(item.item_Code)}
                            value={item?.priceListName ? item?.priceListName : "MRP"}
                        />
                        {selectedItemCode === item?.item_Code && priceList && PriceListShow && (
                            <ul className="priceListContainer">
                                {priceList.map((priceItem, index) => (
                                    <li
                                        key={index}
                                        className="priceListItem"
                                        onClick={() => handlePriceClick(priceItem, item?.item_Code)}
                                    >
                                        {priceItem.priceList} - {priceItem.unitPrice}
                                    </li>
                                ))}
                            </ul>
                        )} */}
                        {cartMap && cartMap[item?.item_Code] && cartMap[item?.item_Code].quantity > 0 ? (
                            <>
                                <button className="addTocart" style={{ display: "none" }}>Add to Cart</button>
                                <div className="d-flex ButtonPosition">
                                    <div className="counter-buttons col-6">
                                        <button
                                            className="minus btn-secondary"
                                            onClick={handleAddToCartClick(index + page * rowsPerPage, item, "Sub")}
                                        >
                                            -
                                        </button>
                                        <input
                                            type="text"
                                            className="Qty-Input"
                                            value={cartMap[item.item_Code].quantity}
                                            onClick={(event) => event.target.select()}
                                            // onChange={(event) => handleInputChange(index + page * rowsPerPage, event, item)}
                                            onChange={
                                                (e) =>{const cartKeys = Object.keys(cartMap);
                                                    const cartIndex = cartKeys.indexOf(item?.item_Code)
                                                     handleQuantityChange(e, cartIndex, 'quantity')}}
                                        />
                                        <button
                                            className="plus btn-secondary"
                                            onClick={handleAddToCartClick(index + page * rowsPerPage, item, "Add")}
                                        >
                                            +
                                        </button>
                                    </div>
                                    <div className="col-5">
                                        <button
                                            className="remove-item"
                                            onClick={handleRemoveItem(index + page * rowsPerPage,item ,"remove")}
                                        >
                                            <HighlightOffIcon />
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <button
                                className="addTocart"
                                onClick={handleAddToCartClick(index + page * rowsPerPage, item, "New")}
                            >
                                Add to Cart
                            </button>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default ItemList;